import React, { useState, useEffect } from 'react';
import googlePlayBadge from '../assets/google-play-badge.png'; // Ruta a la imagen del botón
import appStoreBadge from '../assets/apple-store-badge.svg'; // Ruta a la imagen del botón

const Lightbox = ({ project, closeLightbox }) => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (project) {
      setIsOpen(true);
    }
  }, [project]);

  // Si no hay proyecto seleccionado, no se renderiza nada
  if (!project) return null;

  const handleClose = () => {
    setIsOpen(false);
    setTimeout(() => {
      closeLightbox();
    }, 300); // Tiempo de transición para el cierre del lightbox
  };

  return (
    <div className={`lightbox-overlay ${isOpen ? 'show' : ''}`} onClick={handleClose}>
      <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
        <h3>{project.title}</h3>
        <p dangerouslySetInnerHTML={{ __html: project.descriptionLarge }}></p> {/* Permite la inclusión de código HTML */}
        {project.thumbnail && (
        <img src={project.thumbnail} alt="Thumbnail" className="lightbox-thumbnail" />
      )}
      <br/>
        {project.url && (
          <button className="lightbox-url-button" onClick={() => window.open(project.url, '_blank')}>
            Ve al sitio
          </button>
        )}
        {project.insta && (
          <button className="lightbox-url-button" onClick={() => window.open(project.insta, '_blank')}>
             {/* <FontAwesomeIcon icon={instagram} className="insta-icon" /> */}
             Ve a Instagram
          </button>
        )}
        {project.urlplaystore && (
        <a href={project.urlplaystore} target="_blank" rel="noopener noreferrer">
          <img src={googlePlayBadge} alt="Disponible en Google Play" className="store-button"/>
        </a>
        )}
        {project.urlappstore && (
        <a href={project.urlappstore} target="_blank" rel="noopener noreferrer">
          <img src={appStoreBadge} alt="Disponible en Google Play" className="store-button"/>
        </a>
        )}
        <br/>
        <button className="lightbox-close-button" onClick={handleClose}>
          Cerrar
        </button>
      </div>
    </div>
  );
};

export default Lightbox;
